module.exports = __webpack_public_path__ + "34736292/img/product-icon-grey.b248963c.svg";